var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Form, Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { actions, Translate, t } from "./..";
import Modal from "../../Layout/Modal";
import { FormGroup } from "../../Forms";

export class TranslateForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  submit(values) {
    let translations = this.props.translations.toJS();
    translations = translations.map((translation) => {
      const { locale } = translation;
      const context = translation.contexts.find((c) => c.id === this.props.context);
      context.values[this.props.value] = values[locale];
      translation.contexts = [context];
      return translation;
    });
    this.props.saveTranslations(translations);
    this.props.close();
  }

  cancel() {
    this.props.close();
  }

  render() {
    const translations = this.props.translations.toJS();
    const languages = translations.map((translation) => translation.locale);

    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: this.props.isOpen, type: "info" }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Translate")), /*#__PURE__*/

      _jsx(Form, { model: "inlineEditModel", onSubmit: this.submit, id: "inlineEdit" }, void 0,
      languages.map((language) => /*#__PURE__*/
      _jsx(FormGroup, { model: `.${language}` }, language, /*#__PURE__*/
      _jsx(Field, { model: `.${language}` }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: language }, void 0,
      language, /*#__PURE__*/
      _jsx("input", { id: language, className: "form-control" }))))))), /*#__PURE__*/







      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-default cancel-button", onClick: this.cancel }, void 0,
      t('System', 'Cancel', null, false)), /*#__PURE__*/

      _jsx("button", { type: "submit", form: "inlineEdit", className: "btn confirm-button btn-primary" }, void 0,
      t('System', 'Submit', null, false)))));




  }
}

TranslateForm.defaultProps = {
  isOpen: false
};










export function mapStateToProps(state) {
  return {
    translations: state.translations,
    isOpen: state.inlineEdit.get('showInlineEditForm'),
    context: state.inlineEdit.get('context'),
    value: state.inlineEdit.get('key')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  { saveTranslations: actions.saveTranslations, close: actions.closeInlineEditTranslation },
  dispatch);

}

export default connect(mapStateToProps, mapDispatchToProps)(TranslateForm);